import { Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Address } from 'ngx-google-places-autocomplete/objects/address';

@Component({
  selector: 'app-address',
  template: `
  <input
    ngx-google-places-autocomplete
    #placesRef="ngx-places"
    (onAddressChange)="handleAddressChange($event)"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [placeholder] = "to.placeholder"
  />
  `,
  styles: [
    `
      input {
        height: 100%;
        width: calc(100% - 20px);
        border: 1px solid #ced4da;
        color: inherit;
        font-size: inherit;
      }
  
      input:focus {
        outline: none;
      }
    `
  ]
})
export class AddressComponent extends FieldType {

  @ViewChild('placesRef', { static: true })
  placesRef!: GooglePlaceDirective;
  formControl!: FormControl;
  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  public handleAddressChange(address: Address) {
    this.to.handleAddressChange(address, this);
  }

}
